module.exports = __webpack_public_path__ + "img/researchTrends_h1.05507b65.png";